/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$(document).ready(function () {

  document.addEventListener('cart:updated', function(event) {
    var cart = event.detail.cart; // Get the updated content of the cart
    console.log(cart);
    var ids = $('#mini-cart').attr('data-claimitms');
    var minval = parseInt($('#mini-cart').attr('data-pricelimit'));
    var totalreqprice = 0;
    $(cart['items']).each(function(i,e){
      if(ids.indexOf(e.id) > -1){        
        totalreqprice += e.final_line_price;
      }
    });
    var ctp = cart['total_price'] - totalreqprice;
    if(ctp < minval){       
      var cnttt = 0;
      var updateData = {};        
      $(cart['items']).each(function(i,e){
        if(ids.indexOf(e.id) > -1){
          updateData[e.id] = 0;
          cnttt++;
        }
      });
      console.log('jijiji');
      if(cnttt > 0){
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {
            updates: updateData
          },
          dataType: 'json',
          async: true,
          error: function (jqXHR, textStatus, errorThrown) {
            console.log('error')            
          },
          success: function(data) {   
            console.log('success')
            $.getJSON('/cart.js', function(cart){
              document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: {
                  cart: cart
                }
              }));
            });                
          }
          
        }); 
      }          
    }
  });
  if ($(".timermain").length > 0) {
    var endtime = $("#timermain").attr("data-timer");
    // Set the date we're counting down to
    var countDownDate = new Date(endtime).getTime();

    // Update the count down every 1 second
    var x = setInterval(function () {
      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      if (days < 10) {
        days = "0" + days;
      }
      var dayshtml = "";
      if (days > 0) {
        dayshtml =
          '<span class="value">' +
          days +
          '<span class="extratext">Days</span></span><span> : </span>';
      }
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      if (hours < 10) {
        hours = "0" + hours;
      }
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      if (seconds < 10) {
        seconds = "0" + seconds;
      }

      // Output the result in an element with id="demo"
      $(".timermain").html(
        dayshtml +
          '<span class="value">' +
          hours +
          '<span class="extratext">Hours</span></span><span> : </span><span class="value">' +
          minutes +
          '<span class="extratext">Minutes</span></span><span> : </span><span class="value">' +
          seconds +
          '<span class="extratext">Seconds</span></span>'
      );

      // If the count down is over, write some text
      if (distance < 0) {
        clearInterval(x);
        if ($(".timermain").closest("announcement-bar-item").length > 0) {
          $(".timermain").closest("announcement-bar-item").remove();
        }
        $(".timermain").remove();
      }
    }, 1000);
  }

  $("body").on(
    "click",
    ".additional-information .section__header",
    function () {
      $(this).toggleClass("opened");
      $(this)
        .closest(".additional-information")
        .find(".multi-column_wp")
        .slideToggle();
    }
  );

  $(".banner-slider").slick({
    dots: true,
    arrows: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 300,
    nextArrow: '<button type="button" data-role="none" class="slick-next"><svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-right  icon--direction-aware " viewBox="0 0 17 14" aria-controls="block-template--24735061999928__slideshow--next"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg></button>',
    prevArrow: '<button type="button" data-role="none" class="slick-prev slick-disabled"><svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-left  icon--direction-aware " viewBox="0 0 17 14"><path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg></button>',
  });

  $(".our_ritual-row").slick({
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 300,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          infinite: true,
        },
      },
    ],
  });

  $(".featured-collection-secondary").slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 300,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          infinite: true,
        },
      },
    ],
  });

  $(".row-ingredient_wrap").slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 1.8,
        },
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1.7,
          arrows: false,
        },
      },
    ],
  });
  $(".blog-post-slider").slick({
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".sg_testimonial_list-wrapper").slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  });
  $(".ingredients-images_grid_wraper").slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  });

  $("body").on("click", ".pao-copy_code", function () {
    var copy_text = $(this);
    var text = $(this).attr("data-dcode");
    var $temp = $("<input>");

    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();    
    
  });

  $('a[href="#calendly"],.calendly-widget_close').click(function (e) {
    e.preventDefault();
    $("#calendly").toggle();
  });

  function scrollToSection(event) {
    event.preventDefault();
    $(".ptn_row a").removeClass("active");
    $(this).addClass("active");
    var $section = $($(this).attr("href"));
    $("html, body").animate(
      {
        scrollTop: $section.offset().top - 180,
      },
      500
    );
  }
  $(".ptn_item-link").on("click", scrollToSection);
  // $(document).on("scroll", onScroll);
});
// function onScroll(event){
//   var scrollPos = $(document).scrollTop() + 200;
//   $('.ptn_row a').each(function () {
//       var currLink = $(this);
//       var refElement = $(currLink.attr("href"));
//       if (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
//         $('.ptn_row a').removeClass("active");
//         currLink.addClass("active");
//       }
//   });
// }
// jQuery(document).ready(function($) {
// }(jQuery));

// UPDATE PRODUCT CONTENT ON VARIANT CHANGE
if ($("body").hasClass("template--product-kits")) {
  document.addEventListener("variant:changed", function (event) {
    let variant = event.detail.variant;
    let form = event.target;

    var product_handle = $("body").attr("product-handle");
    $.get(`/products/${product_handle}?variant=${variant.id}`, function (data) {
      $(".product-variant-meta__title").html(
        $(data).find(".product-variant-meta__title").html()
      );
      $(".product-meta__type").html($(data).find(".product-meta__type").html());
      $(".product-form__variant-description").html(
        $(data).find(".product-form__variant-description").html()
      );
      $(".meta-img-with-text-full").html(
        $(data).find(".meta-img-with-text-full").html()
      );
      $(".meta-ingredients-additives").html(
        $(data).find(".meta-ingredients-additives").html()
      );
      $(".video-section").html($(data).find(".video-section").html());
    });
  });
}
document.addEventListener("variant:changed", function (event) {
  let variant = event.detail.variant;
  let form = event.target;
  var product_handle = $("body").attr("product-handle");
  $.get(`/products/${product_handle}?variant=${variant.id}`, function (data) {
    $(".variant-volume_text")?.html(
      $(data).find(".variant-volume_text").html()
    );
    $(".variant_image-banner")?.html(
      $(data).find(".variant_image-banner").html()
    );
  });
});

jQuery.noConflict();
jQuery(document).ready(function ($) {
    $(".related-product-grid").slick({
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
    });
});